import { useState } from "react";
import { ArrowRight, Check } from "lucide-react";
import { toast } from "sonner";
import { subscribeNewsletter, trackEvent } from "../../lib/api";

export const NewsletterForm = ({ source = "website", dark = false }) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await subscribeNewsletter(email, source);
      trackEvent("newsletter_signup", source);
      setDone(true);
      setEmail("");
      toast.success("You're subscribed to MATRIVON Insights.");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid="newsletter-success"
        className={`flex items-center gap-2 text-sm ${dark ? "text-white/80" : "text-brand-blue"}`}
      >
        <Check className="h-4 w-4" /> Subscribed. Thank you.
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid={`newsletter-form-${source}`} className="flex w-full max-w-md">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Business email"
        data-testid={`newsletter-email-input-${source}`}
        className={`h-11 w-full border px-3 text-sm outline-none focus:ring-2 focus:ring-brand-blue ${
          dark
            ? "border-white/20 bg-white/5 text-white placeholder:text-white/40"
            : "border-brand-line bg-white text-brand-ink placeholder:text-brand-muted"
        }`}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`newsletter-submit-${source}`}
        className="inline-flex h-11 shrink-0 items-center gap-1.5 bg-brand-blue px-4 text-sm font-semibold text-white transition-colors hover:bg-brand-bluedark disabled:opacity-60"
      >
        {loading ? "…" : <>Subscribe <ArrowRight className="h-4 w-4" /></>}
      </button>
    </form>
  );
};
